import { BreadcrumbData, AppBreadcrumbs, InitialBreadcrumb } from "@duosoftbg/nacid-components";
import { ProcessEnvironments } from "@duosoftbg/nacid-frontoffice-components";

export const breadcrumbData: BreadcrumbData = [
  { path: "/", name: "t.page.registers", isHomePage: true },
  { path: "/marks", name: "t.page.marksSearch" },
  { path: "/marks/view", name: "l.mark", queryParamSuffix: "id" },
  { path: "/academic-recognitions", name: "t.page.academicRecognition" },
  { path: "/academic-recognitions/view", name: "t.detail.academicRecognition" },
  { path: "/professional-qualifications", name: "t.page.professionalQualifications" },
  { path: "/professional-qualifications/view", name: "t.detail.professional.qualification" },
  { path: "/ar-uni-entry-request", name: "t.arUniEntryRequest" },
  { path: "/ar-uni-entry-request/new", name: "t.arUniEntryRequest.new.short" },
  { path: "/ar-uni-entry-request/list/edit", name: "t.arUniEntryRequest.edit.short" },
  { path: "/ar-uni-entry-request/list/view", name: "t.arUniEntryRequest.view.short" },
  { path: "/secondary-recognition/checkup", name: "t.seRecognition.checkup.short" },
  { path: "/certificate/secondary-recognition/qrcode/view", name: "t.seRecognition.qr.view.short" },
  { path: "/ar-uni-entry-request/list", name: "t.arUniEntryRequest.list.short" },
  {
    path: "/admin-console/ar-uni-entry-request",
    name: "t.acArUniEntryRequest",
    parentOverride: [
      { path: `${ProcessEnvironments.Module.FrontOffice.Portal}/admin-console`, name: "t.adminConsole" },
    ],
  },
  {
    path: "/admin-console/ar-uni-entry-request/view",
    name: "t.acArUniEntryRequest.view",
  },
];

export const initialBreadcrumb: InitialBreadcrumb = [
  { path: `${ProcessEnvironments.Module.FrontOffice.Portal}`, name: "l.start", external: true },
];

const Breadcrumbs = () => {
  return <AppBreadcrumbs data={breadcrumbData} initial={initialBreadcrumb} />;
};

export default Breadcrumbs;
